import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import {
  Form,
  Input,
  Upload,
  Button,
  Switch,
  Select,
  Row,
  Col,
  Tabs,
  Flex,
  Modal,
  Space,
  Table,
  TableProps,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  PlusCircleFilled,
  PlusCircleOutlined,
  SearchOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  addSelectedPart,
  removeSelectedPart,
  FetchEquipmentList,
} from "../../redux/actions/action";
import styles from "./equipmentPartListPopup.module.css";
import tool from "../../assets/icons/tool.svg";
import aperture from "../../assets/icons/aperture.svg";
import location from "../../assets/icons/location1.svg";

function EquipmentPartListPopup(props) {
  const dispatch = useDispatch();

  const [selectEquipment, setSelectEquipment] = useState(null);

  const equipmentList = useSelector((state) => {
    return state.user.equipmentList;
  });

  useEffect(() => {
    dispatch(FetchEquipmentList());
  }, []);

  const handleCheckboxChange = (e, record) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      // Uncheck previously selected checkbox
      if (selectEquipment !== null) {
        const prevCheckbox = document.getElementById(
          `checkbox_${selectEquipment}`
        );
        if (prevCheckbox) {
          prevCheckbox.checked = false;
        }
      }
      setSelectEquipment(record.assetId, record.assetName);
      props.onSelectEquipmentChange(record.assetId, record.assetName);
    } else {
      setSelectEquipment(null);
      props.onSelectEquipmentChange(null);
    }
  };

  const partTableColumn = [
    {
      title: "",
      dataIndex: "assetId",
      key: "assetId",
      render: (text, record) => (
        <div className="custom-checkbox-wrap">
          <input
            type="checkbox"
            id={`checkbox_${record.assetId}`}
            onChange={(e) => handleCheckboxChange(e, record)}
          />
          <span className="checkmark"></span>
        </div>
      ),
    },
    {
      title: "",
      dataIndex: "assetName",
      key: "assetName",
      render: (text, record) => (
        <div className={styles.icon_text}>
          <div className={styles.icon_wrap}>
            <img src={getImageSource(record.assetType)} alt="part icon" />
          </div>
          {text}
        </div>
      ),
    },
    {
      title: "",
      dataIndex: "assetType",
      key: "assetType",
      render: (text, record) => <div className={styles.icon_text}>{text}</div>,
    },
  ];

  const getImageSource = (type) => {
    // Add your logic to map part types to image sources
    switch (type) {
      case "Equipment":
        return aperture;
      case "Part":
        return tool;
      case "Facility":
        return location;
      // Add more cases as needed
    }
  };

  const [equipmentAndPartSearch, setEquipmentAndPartSearch] = useState("");

  return (
    <>
      <div
        className={`${styles.addPartPopup} ${
          props.modalOpen ? styles.show : ""
        }`}
      >
        <div className={styles.part_popup_inner}>
          <div className={styles.part_popup_header}>
            <div className={styles.title_wrap}>
              <Flex gap="small" className={styles.flex}>
                <h2>Equipments & Parts</h2>
                <div className={styles.list_toggle_btn}>
                  <div className={styles.btn_wrap}>
                    <button type="button" className={styles.active_btn}>
                      List
                    </button>
                    <button type="button">Tree</button>
                  </div>
                </div>
                <div className={styles.search_input}>
                  <input
                    type="text"
                    placeholder="Search"
                    value={equipmentAndPartSearch}
                    onChange={(e) => {
                      setEquipmentAndPartSearch(e.target.value);
                    }}
                  />
                  <Button
                    type="text"
                    shape="circle"
                    icon={<SearchOutlined />}
                  />
                </div>
              </Flex>
            </div>
            <div className={styles.close_btn_wrap}>
              <Button
                type="text"
                shape="circle"
                icon={<CloseCircleOutlined />}
                onClick={props.modalHideEv}
              />
            </div>
          </div>
          <div className={styles.popup_body}>
            <div className={`${styles.table_wrapper} part-table-wrapper`}>
              <Table
                columns={partTableColumn}
                // dataSource={equipmentList}
                dataSource={equipmentList.filter((item) =>
                  item?.assetName
                    .toLowerCase()
                    .includes(equipmentAndPartSearch.toLowerCase())
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// export default connect(mapStateToProps, mapDispatchToProps)(GroupListPopup);
export default EquipmentPartListPopup;
